import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {PartnerContactDataservice} from './impl/service/ngrx/partnerContact.dataservice';
import {PartnerContactRepository} from './impl/service/ngrx/partnerContact.repository';

@NgModule()
export class PartnerContactModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                service: PartnerContactRepository,
                dataService: PartnerContactDataservice,
    ) {

        entityDataService.registerServices({
            PartnerContact: dataService,
        });

        entityServices.registerEntityCollectionServices({
            PartnerContact: service,
        });
    }
}
